import axios from "axios";
import { saveAs } from "file-saver";
import Papa from "papaparse";

export const exportAttendanceCsv = async (rawData, type, startDate, endDate) => {



  console.log("startDate", startDate)
  console.log("endDate", endDate)

  const start = new Date(startDate);
  const end = new Date(endDate);

  // const today = new Date();f
  const month = start.getMonth() + 1;
  const year = start.getFullYear();
  const daysInMonth = new Date(year, month, 0).getDate();

  const employeeMap = {};

  rawData.forEach((entry) => {
    const {
      empid,
      employeeName,
      date,
      numberOfHours,
      projectName = "",
      location = "",
      jobTitle = ""
    } = entry;

    const day = new Date(date).getDate();
    const hours = parseFloat(numberOfHours) || 0;

    if (!employeeMap[employeeName]) {
      employeeMap[employeeName] = {
        empid,
        days: {},
        projectName,
        location,
        jobTitle
      };
    }

    let status = "";
    if (hours >= 5) status = "P";
    else if (hours > 0 && hours < 5) status = "H";
    else status = "A";

    // let status = "";
    // if (hours >= 8) status = "P";
    // else if (hours >= 4 && hours < 8) status = "H";
    // else status = "A";

    employeeMap[employeeName].days[day] = status;
  });

  const headers = ["Employee Name", "Designation"];
  for (let d = 1; d <= daysInMonth; d++) {
    headers.push(d.toString().padStart(2, "0"));
  }
  headers.push("Total Paid Days", "Total P", "Total H", "Total A", "Total L", "Total R", "Project Name", "Location");

  const rows = [];
  const sortedEmpNames = Object.keys(employeeMap).sort();

  for (const empName of sortedEmpNames) {
    const { empid, days, projectName, location, jobTitle } = employeeMap[empName];
    const row = [empName, jobTitle];
    let totalP = 0;
    let totalH = 0;
    let totalA = 0;
    let totalL = 0;
    let totalR = 0;

    for (let d = 1; d <= daysInMonth; d++) {
      const dateKey = `${year}-${String(month).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
      console.log("dateKey----", dateKey)
      let status = days[dateKey];  // date-based access

      if (!status) {
        try {
          const res = await axios.post(`/attendance/getAttendanceStatus`, { empid, date: dateKey });
          status = res.data.status;
        } catch (err) {
          console.error(`Failed to fetch status for empid ${empid} on ${dateKey}`, err);
          status = "E";
        }
      }

      row.push(status);

      if (status === "P") totalP++;
      else if (status === "H") totalH++;
      else if (status === "A") totalA++;
      else if (status === "L") totalL++;
      else if (status === "R") totalR++;
    }

    const totalDays = totalP + (totalH / 2) + totalR;
    row.push(totalDays, totalP, totalH, totalA, totalL, totalR, projectName, location);
    rows.push(row);
  }

  const csv = Papa.unparse({ fields: headers, data: rows });
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

  const filename =
    type === "employee"
      ? `Attendance_Employee_Wise-${month}-${year}.csv`
      : `Attendance_Project_Wise-${month}-${year}.csv`;

  saveAs(blob, filename);
};
